import { render, staticRenderFns } from "./addShopLabel.vue?vue&type=template&id=02b10c72&scoped=true"
import script from "./addShopLabel.vue?vue&type=script&lang=js"
export * from "./addShopLabel.vue?vue&type=script&lang=js"
import style0 from "./addShopLabel.vue?vue&type=style&index=0&id=02b10c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b10c72",
  null
  
)

export default component.exports